import AuspicienteModel from "../../domain/models/auspiciante.model";
import SponsorService from "../../infraestructure/services/sponsor.service";
import ErrorsUtil from "../../infraestructure/utils/errors.util";
import { DEFAULT_ERROR_MESSAGE } from "../../shared/static/constants.static";


const useSponsorFunctions = () => {
    const sponsorService = new SponsorService();

    const getAllSponsors = async (): Promise<AuspicienteModel[]> => {
        try {
            const response = await sponsorService.getAllSponsors();
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const createSponsor = async (sponsor: AuspicienteModel): Promise<AuspicienteModel> => {
        try {
            const response = await sponsorService.createSponsor(sponsor);
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const updateSponsor = async (sponsor: AuspicienteModel): Promise<AuspicienteModel> => {
        try {
            const response = await sponsorService.updateSponsor(sponsor);
            if (!response) throw new Error(DEFAULT_ERROR_MESSAGE)
            return response;
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    const deleteSponsor = async (id: number): Promise<void> => {
        try {
            await sponsorService.deleteSponsor(id);
        } catch (error) {
            ErrorsUtil.manageError(error)
            throw error;
        }
    }

    return {
        getAllSponsors,
        createSponsor,
        updateSponsor,
        deleteSponsor
    }
}

export default useSponsorFunctions;